import type { LengthCode, UnitCode } from '@icommerce/units';
import { getUnitCodeForUnitSystem } from '@icommerce/units';
import { useProductPageStore } from './states/useProductPageStore';
import { getLengthUnitCodeByPriceType } from '@libs/product.helper';
import { CATEGORY_3D_MOVEMENT } from '@icommerce/categories';

export const useLengthUnitCodeForUnitSystem = (): LengthCode | undefined => {
  const unitSystem = useProductPageStore(state => state.unitSystem);
  const priceType = useProductPageStore(state => state.priceData.priceType);
  const currentCategory = useProductPageStore(state => state.breadcrumbItems);

  const isTriflex = currentCategory.some(item => item.key === CATEGORY_3D_MOVEMENT);

  const metricLengthUnitCode = getLengthUnitCodeByPriceType(priceType, unitSystem, isTriflex);
  return metricLengthUnitCode && (getUnitCodeForUnitSystem(metricLengthUnitCode as UnitCode, unitSystem) as LengthCode);
};
